module.exports = __webpack_public_path__ + "img/logo-8.8ad1b12f.png";